import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Calendar, MapPin, Hash } from "lucide-react";

const statusColor = {
  pending_payment: "bg-amber-500/15 text-amber-600 border-amber-500/30",
  confirmed: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
  cancelled: "bg-red-500/15 text-red-700 border-red-500/30",
};

export default function MyBookings() {
  const { user, loading } = useAuth() || {};
  const nav = useNavigate();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    api.get("/bookings/mine").then(({ data }) => setBookings(data));
  }, [user, loading, nav]);

  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="eyebrow mb-3" style={{ color: "#0B1F3A" }}>Your account</div>
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter mb-10">My bookings</h1>

      {bookings.length === 0 ? (
        <div className="bg-white rounded-2xl border border-black/5 p-12 text-center">
          <p className="text-[#0B1F3A]/70 mb-6">You don't have any bookings yet.</p>
          <Link to="/fleet" className="btn-gold">Browse the fleet</Link>
        </div>
      ) : (
        <div className="grid gap-4">
          {bookings.map((b) => (
            <div key={b.id} className="bg-white rounded-2xl border border-black/5 p-5 grid md:grid-cols-6 gap-5 items-center" data-testid={`my-booking-${b.reference}`}>
              <img src={b.vehicle_image} alt={b.vehicle_name} className="w-full md:col-span-1 aspect-video object-cover rounded-lg" />
              <div className="md:col-span-3 space-y-1">
                <div className="font-display font-bold text-xl">{b.vehicle_name}</div>
                <div className="flex flex-wrap items-center gap-4 text-sm text-[#0B1F3A]/60">
                  <span className="flex items-center gap-1"><Hash className="w-3.5 h-3.5" /> {b.reference}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {new Date(b.pickup_datetime).toLocaleDateString()} → {new Date(b.return_datetime).toLocaleDateString()}</span>
                  <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {b.pickup_location}</span>
                </div>
              </div>
              <div className="md:col-span-1">
                <span className={`text-xs uppercase tracking-widest border px-3 py-1 rounded-full ${statusColor[b.status] || "bg-gray-100 border-gray-200 text-gray-700"}`}>{b.status.replace("_", " ")}</span>
              </div>
              <div className="md:col-span-1 text-right">
                <div className="text-2xl font-display font-extrabold text-[#0B1F3A]">${b.total_amount.toFixed(2)}</div>
                <div className="text-[10px] uppercase tracking-widest text-[#0B1F3A]/50">{b.days} day{b.days > 1 ? "s" : ""}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
